import { useEffect, useState } from 'react';

import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import CurrentThreadContainer from '../containers/CurrentThreadContainer';

import ThreadTemplateComponent from '../../MessagesTemplate/ThreadTemplate/ThreadTemplateComponent';

import {
  ACTIVE_THREAD_CONTAINER,
  ACTIVE_THREAD_FILE,
  ACTIVE_THREAD_INPUT,
  ACTIVE_THREAD_MESSAGES,
  ACTIVE_THREAD_TITLE,
} from '../constants';

import { history } from '../../../store';
import { MessageThreadSkeleton } from '../../Shared/skeletons';

const MessagesWidgetComponent = ({
  currentChatId,
  handleNewUserMessage,
  widgetHeader,
  isInputDisabled,
  titleWithUrl,
  subtitleWithUrl,
  isMobileScreen,

  isAttachIconShown,
  attachModalType,
  setAttachModalType,
  checkNewAttachment,
  attachmentDocumentId,
  attachmentDocumentName,
  setDocumentAsAttachment,
  confirmSendingMultiRecipients,
  onReply,
  isClosed,
  newChatData,
  recipientsCount,
  cancelNewChatCreation,
}) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setInputValue('');
  }, [currentChatId]);

  const characterLimit = 3000;

  const title = titleWithUrl ?? widgetHeader?.title;

  const showInput =
    !!(!isClosed && currentChatId && title) ||
    newChatData?.numberOfRecipients > 0;

  const hasSelectedThread = currentChatId > 0;

  const arrowBackOnclick = () => {
    !isEmpty(newChatData) && cancelNewChatCreation();
    history.push('/messages');
  };
  const isArrowBackActive = isMobileScreen && !newChatData?.isReply;
  const isMessagesContainerActive = !hasSelectedThread && isEmpty(newChatData);
  const isCurrentThreadActive = showInput || isClosed;

  const containerIds = {
    containerId: ACTIVE_THREAD_CONTAINER,
    containerTitleId: ACTIVE_THREAD_TITLE,
    messagesContainerId: ACTIVE_THREAD_MESSAGES,
    messagesInputId: ACTIVE_THREAD_INPUT,
    messagesFileId: ACTIVE_THREAD_FILE,
  };

  return (
    <ThreadTemplateComponent
      arrowBackOnclick={arrowBackOnclick}
      characterLimit={characterLimit}
      containerIds={containerIds}
      inputValue={inputValue}
      isArrowBackActive={isArrowBackActive}
      isCurrentThreadActive={isCurrentThreadActive}
      isInputDisabled={isInputDisabled}
      isMessagesContainerActive={isMessagesContainerActive}
      confirmSendingMultiRecipients={confirmSendingMultiRecipients}
      setInputValue={setInputValue}
      showInput={showInput}
      subtitleWithUrl={subtitleWithUrl}
      titleWithUrl={titleWithUrl}
      title={title}
      widgetHeader={widgetHeader}
      setAttachModalType={setAttachModalType}
      isAttachIconShown={isAttachIconShown}
      recipientsCount={recipientsCount}
      handleNewUserMessage={handleNewUserMessage}
      attachModalType={attachModalType}
      checkNewAttachment={checkNewAttachment}
      attachmentDocumentId={attachmentDocumentId}
      attachmentDocumentName={attachmentDocumentName}
      setDocumentAsAttachment={setDocumentAsAttachment}
    >
      {showInput || isClosed ? (
        <CurrentThreadContainer
          currentChatId={currentChatId}
          onReply={onReply}
        />
      ) : (
        <MessageThreadSkeleton />
      )}
    </ThreadTemplateComponent>
  );
};

MessagesWidgetComponent.defaultProps = {
  currentChatId: null,
  widgetHeader: null,
  recipientsCount: null,
  titleWithUrl: null,
  subtitleWithUrl: null,
  attachmentDocumentId: null,
  attachmentDocumentName: null,
  attachModalType: null,
  newChatData: null,
};

MessagesWidgetComponent.propTypes = {
  currentChatId: PropTypes.number,
  handleNewUserMessage: PropTypes.func.isRequired,
  widgetHeader: PropTypes.instanceOf(Object),
  isInputDisabled: PropTypes.bool.isRequired,
  recipientsCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  attachModalType: PropTypes.string,
  setAttachModalType: PropTypes.func.isRequired,
  isAttachIconShown: PropTypes.bool.isRequired,
  titleWithUrl: PropTypes.node,
  subtitleWithUrl: PropTypes.node,
  checkNewAttachment: PropTypes.func.isRequired,
  attachmentDocumentId: PropTypes.number,
  attachmentDocumentName: PropTypes.string,
  setDocumentAsAttachment: PropTypes.func.isRequired,
  onReply: PropTypes.func.isRequired,
  isClosed: PropTypes.bool.isRequired,
  isMobileScreen: PropTypes.bool.isRequired,
  newChatData: PropTypes.instanceOf(Object),
  confirmSendingMultiRecipients: PropTypes.func.isRequired,
  cancelNewChatCreation: PropTypes.func.isRequired,
};

export default MessagesWidgetComponent;
